import React from 'react';
import PropTypes from 'prop-types';
import { MDText } from 'i18n-react';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import Button from '@adsk/bim360-matrix-react-button';

import './_TryAgainNotificationMessage.scss';

const TryAgainNotificationMessage = ({ children, onTryAgain }) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));
  return (
    <span className="TryAgainNotificationMessage__remove-error-message">
      {children}
      <Button
        className="TryAgainNotificationMessage__notification-try-again"
        styleType={Button.StyleType.INLINE_LINK}
        onClick={onTryAgain}
      >
        {T.translate('TRY_AGAIN')}
      </Button>
    </span>
  );
};

TryAgainNotificationMessage.propTypes = {
  children: PropTypes.node,
  onTryAgain: PropTypes.func
};

export default TryAgainNotificationMessage;
